export default {
  btnColor: '#2A2A2A',
  mainColor: '#0A4D68',
  mainColor2: '#0f6c91',
  lightBlue: '#B1B9D7',
  gray: '#C3C3C3',
}
